/**
 * company
 */
'use strict';
import AppCompany from '@/_modules/app_company';

document.addEventListener('DOMContentLoaded', () => {
  new AppCompany();
}, false);

window.addEventListener('load', () => {

}, false);

window.addEventListener('unload', () => {}, false);

window.addEventListener('pageshow', function(event){
  if (event.persisted) {
    window.location.reload();
  }
});

